export const TEAM_FORM = "configTeamForm";
export const TOTAL_WEIGHTS_FOR_WEIGHTED_DISTRIBUTION = 10;